<template>
    <div class="price-wrapper mb-2">
        <!--
        <div v-if="offer.rateCode == 'PRO'" class="badge badge-success">
            Special Deal
        </div>
        -->
        {{ offer }}
        <div><small>{{ dateDifference(search.date.checkin, search.date.checkout) }} {{ $tc('night', dateDifference(search.date.checkin, search.date.checkout)) }}</small></div>
        <div class="display-4" v-if="offer.totalRate">
            &euro; {{ formatPrice(offer.totalRate) }}
        </div>
        <div>
            <small>Includes taxes and fees</small>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        name: 'PartnerPrice',
        props: {
            offer: {
                type: Object,
                required: true
            },
            search: {
                type: Object,
                required: true
            }
        },
        methods: {
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            dateDifference(date1, date2) {
                var a = dayjs(date2, "YYYY-MM-DD");
                var b = dayjs(date1, "YYYY-MM-DD");
                return a.diff(b, 'days');
            },
            currency(iso) {
                if (iso == 'EUR') {
                    return '€';
                }
            },
        },
        i18n: { // `i18n` option, setup locale info for component
            messages: {
                en: {
                    night: 'night | nights',
                    adult: 'adult | adults'
                }
            },
        }
    }
</script>

<style scoped>

</style>